import router from '@/router/index.js';
export const contracteProjectStatus = {
  methods: {
    defaultBtnText (purchaseStatus) {
      if (purchaseStatus === 82) {
        return '确认合同';
      } else if (purchaseStatus === 85) {
        return '支付项目款';
      } else {
        return '';
      }
    },
    defaultBtnAction (item) {
      if (item.purchaseStatus === 82) {
        router.push('/person-center/purchase-business/contracting-project/contracting-transaction-list?id=' + item.purchaseId);
      } else if (item.purchaseStatus === 85) {
        router.push('/person-center/purchase-business/contracting-project/contracting-pay-list?id=' + item.purchaseId);
      }
    }
  }
};
